import moment from "moment";

const initalState = {
  language: "English",
  portfolioId: 0,
  clinicianId: 0,
  status: "All Status",
  fromDate: moment()?.subtract(14, "days"),
  toDate: moment()?.add(14, "days"),
  // fromDatePending: moment()?.subtract(40, "days"),
  fromDatePending: moment(new Date("2024-08-01")),
  toDatePending: moment()?.add(14, "days"),
  fromDateConfirmId: moment(new Date("2024-08-01")),
  toDateConfirmId: moment()?.add(14, "days"),
  fromDateConfirmService: moment(new Date("2024-08-01")),
  toDateConfirmService: moment()?.add(14, "days"),
  fromDateSchedule: moment(new Date("2024-08-01")),
  toDateSchedule: moment()?.add(14, "days"),
  fromDateInvoice: moment(new Date("2024-08-01")),
  toDateInvoice: moment()?.add(14, "days"),
  fromDateInvSum: moment(new Date("2024-08-01")),
  toDateInvSum: moment()?.add(14, "days"),
  fromDateSum: moment(new Date("2024-08-01")),
  toDateSum: moment()?.add(14, "days"),
  fromDateApp: moment(new Date("2024-08-01")),
  toDateApp: moment()?.add(14, "days"),
  fromDateConfirmIdRep: moment(new Date("2024-08-01")),
  toDateConfirmIdRep: moment()?.add(14, "days"),
  fromDateByService: moment(new Date("2024-08-01")),
  toDateByService: moment()?.add(14, "days"),
  activeTab: "Portfolio",
  activeList: "Pending",
  pendingActiveList: "Pending",
  confirmedActiveList: "Confirmed",

  patientStatus: "Active"
};

const reducer = (state = initalState, action) => {
  switch (action.type) {
    case "UPDATE_LOGGEDINUSER": return { ...state, loggedInUserId: action?.payload };
    case "CHANGESTATE":
      return {
        ...state,
        ...action?.payload,
      };
    default:
      return state;
  }
};

export { reducer };